import { render, staticRenderFns } from "./PatientAppointment.vue?vue&type=template&id=03893bc7&scoped=true"
import script from "./PatientAppointment.vue?vue&type=script&lang=js"
export * from "./PatientAppointment.vue?vue&type=script&lang=js"
import style0 from "./PatientAppointment.vue?vue&type=style&index=0&id=03893bc7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03893bc7",
  null
  
)

export default component.exports